import { z } from "zod"

// ── L'assistant du support : la question, l'historique, les limites (chantier ASI) ──

export const ASSISTANT_LIMITS = {
  /** A11 : caracteres d'une question, blancs autour exclus */
  questionMaxChars: 1000,
  /** A11 : questions par compte et par jour de Paris (decision du 2026-11-03, « pour l'instant ») */
  perDay: 1000,
  /** Les messages precedents que le navigateur renvoie avec la question */
  historyMaxMessages: 20,
  historyMessageMaxChars: 4000,
  /** COP : le resume du plan, et le retour de l'editeur (un refus) */
  planMaxChars: 30000,
  retourMaxChars: 2000,
  /** A12 : les messages de la conversation jointe a une demande au support */
  joinedMaxMessages: 40,
} as const

export const assistantMessageSchema = z.object({
  role: z.enum(["user", "assistant"]),
  text: z.string().max(ASSISTANT_LIMITS.historyMessageMaxChars),
})
export type AssistantMessage = z.infer<typeof assistantMessageSchema>

export const assistantQuestionSchema = z.object({
  question: z
    .string()
    .trim()
    .min(1, "Écrivez votre question.")
    .max(ASSISTANT_LIMITS.questionMaxChars, "Une question fait 1 000 caractères au plus."),
  history: z.array(assistantMessageSchema).max(ASSISTANT_LIMITS.historyMaxMessages).default([]),
  page: z.object({
    path: z.string().max(500),
    /** L'outil actif de l'editeur, s'il y en a un */
    tool: z.string().max(40).optional(),
  }),
  /** COP : le resume du plan, quand l'editeur peut agir ; sans lui, aucun outil n'est offert */
  plan: z.string().max(ASSISTANT_LIMITS.planMaxChars).optional(),
  /** COP : l'endroit montre sur le plan, en cm */
  point: z.object({
    x: z.number(),
    y: z.number(),
    /** Le mur le plus proche, et la position sur lui */
    mur: z.string().max(20).optional(),
    position: z.number().optional(),
  }).optional(),
  /** COP : ce que l'editeur repond a une proposition (un refus et sa raison) */
  retour: z.string().max(ASSISTANT_LIMITS.retourMaxChars).optional(),
  /** COP : pourquoi l'assistant ne peut pas agir ici (C1) */
  contexte: z.enum(["accueil", "lecture", "3d"]).optional(),
})
export type AssistantQuestion = z.infer<typeof assistantQuestionSchema>
